import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-printer",
  "use": "icon-printer-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-printer\">\n<path d=\"M161.3,58.3H150V41.7c0.4-8.8-6.4-16.3-15.2-16.7H65.2c-8.8,0.4-15.6,7.9-15.2,16.7v16.7H38.7c-12.2,0.1-22,10-22,22.3v55.5\n\tc0,12.2,9.8,22.2,22,22.2h7.2c0,9.2,7.5,16.7,16.7,16.7h75c9.2,0,16.7-7.5,16.7-16.7h7.2c12.2-0.1,22-10,22-22.3V80.6\n\tC183.4,68.4,173.5,58.4,161.3,58.3z M66.7,41.7h66.7v16.7H66.7V41.7z M62.5,158.3V125h75v33.3H62.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol